import { MessageMedium } from 'constants/messageMediums';
import {
  CampaignLabel,
  DataScienceOptimization,
  RecurrenceSchedule,
} from 'modules/domains/campaign';
import { Experiment } from 'modules/domains/experiment';
import { GRAPHQL_TYPENAMES, GraphQLTypeNameData } from 'modules/graphql/types';
import { TemplateType } from 'modules/templateEditor/common';

export type CampaignList = {
  id: number;
  name: string;
};

export type CampaignId = number;

export type CampaignIdData = {
  id: CampaignId;
};

export type Workflow = {
  id: number;
  name: string;
};

export enum CampaignStateDefinitions {
  Aborted = 'Aborted',
  Archived = 'Archived',
  Draft = 'Draft',
  Finished = 'Finished',
  Ready = 'Ready',
  Recurring = 'Recurring',
  Running = 'Running',
  Recalling = 'Recalling',
  Recalled = 'Recalled',
  Scheduled = 'Scheduled',
}

export enum CampaignTypeDefinitions {
  ApiTriggered = 'ApiTriggered',
  Blast = 'Blast',
  Eligibility = 'Eligibility',
  WithAI = 'WithAI',
  WithExperiment = 'WithExperiment',
  WorkflowTriggered = 'WorkflowTriggered',
}

export type QuietHours = {
  startTime: string;
  endTime: string;
} | null;

export type Campaign = {
  campaignAlertsEnabled?: boolean;
  campaignState: CampaignStateDefinitions;
  campaignTypeDefinition: CampaignTypeDefinitions;
  createdAt: string;
  createdBy: string;
  customQuietHours: QuietHours;
  dataScienceOptimizations: DataScienceOptimization[];
  endedAt: string | null;
  experiments: Experiment[];
  id: CampaignId;
  ignoreFrequencyCap?: boolean;
  labels: CampaignLabel[];
  lists: CampaignList[];
  messageMedium: MessageMedium;
  mobileAppIds?: number[];
  name: string;
  placementId?: number;
  priorityLevel?: number;
  schedulerMsgParams: {
    recurDays: number;
    recurSchedule?: RecurrenceSchedule;
    endDate: { timestamp: string; timezone: string };
  } | null;
  startAt: string | null;
  suppressionLists: CampaignList[];
  templateContentPreview: string;
  templateId: number;
  templateType: TemplateType;
  updatedAt: string | null;
  updatedBy: string;
  workflow: Workflow | null;
  isFavorite: boolean;
};

export type GraphQLCampaign = Campaign & GraphQLTypeNameData<GRAPHQL_TYPENAMES.CAMPAIGN>;
